$(function () {

    function initializeFileList() {
        const filePanel = $('#file-list-panel');
        if (!filePanel.length) return;

        function loadFiles(folder_uuid, order_type = 'file_name') {
            let url = $('#file-list-panel').data('file_list_url');

            fetch(url + folder_uuid + '&sort_by=' + order_type , {
                method: 'GET'
            })
                .then(response => response.json())
                .then(data => {
                    if (data.success) {
                        $('#file-list-panel').html(data.content);
                        $('#folder-update-form-name').val(data.folder_name);
                        if (data.folder_is_private == 1) {
                            $('#folder-update-form-is_private').prop('checked', true);
                        } else {
                            $('#folder-update-form-is_private').prop('checked', false);
                        }
                        if (data.folder_is_public == 1) {
                            $('#folder-update-form-is_public').prop('checked', true);
                        } else {
                            $('#folder-update-form-is_public').prop('checked', false);
                        }
                    } else {
                        bootbox.alert('Chyba při načítání souborů: ' + data.error);
                    }
                })
                .catch(error => {
                    console.error('Load error:', error);
                    bootbox.alert('Došlo k neočekávané chybě při ncačítání souborů.');
                })
                .finally(() => {
                    console.log('Finished');
                });

        }

        $(document).on('click', '.show-folder', function (e) {
            loadFiles($(this).data('folder_uuid'));
        });

        $(document).on('click', '.file-delete', function (e) {
            e.preventDefault();
            let url = $(this).data('url');
            bootbox.confirm({
                title: 'Potvrzení',
                backdrop: true,
                message: 'Opravdu smazat soubor?',
                buttons: {
                    confirm: { label: 'Ano', className: 'btn-success' },
                    cancel: { label: 'Ne', className: 'btn-danger' }
                },
                callback: function (result) {
                    if (result) {
                        fetch(url, {
                            method: 'GET'
                        })
                            .then(response => response.json())
                            .then(data => {
                                if (data.success) {
                                    loadFiles($('#file-list-envelope').data('current_folder'));
                                } else {
                                    bootbox.alert('Chyba při mazání souboru: ' + data.error);
                                }
                            })
                            .catch(error => {
                                console.error('Delete error:', error);
                                bootbox.alert('Došlo k neočekávané chybě při mazání souboru.');
                            });
                        return true;
                    } else {
                        return true;
                    }
                }
            });
        });

        $(document).on('click', '.folder-delete', function (e) {
            e.preventDefault();
            let url = $(this).data('url');
            bootbox.confirm({
                title: 'Potvrzení',
                backdrop: true,
                message: 'Opravdu smazat složku včetně všech souborů a podsložek? Tuto akci nelze vrátit zpět.',
                buttons: {
                    confirm: { label: 'Ano', className: 'btn-success' },
                    cancel: { label: 'Ne', className: 'btn-danger' }
                },
                callback: function (result) {
                    if (result) {
                        fetch(url, {
                            method: 'GET'
                        })
                            .then(response => response.json())
                            .then(data => {
                                if (data.success) {
                                    document.location = $('#file-list-panel').data('page_refresh_url') + (data.parent_uuid || '');
                                } else {
                                    bootbox.alert('Chyba při mazání složky: ' + data.error);
                                }
                            })
                            .catch(error => {
                                console.error('Delete error:', error);
                                bootbox.alert('Došlo k neočekávané chybě při mazání složky.');
                            });
                    }
                    return true;
                }
            });
        });

        $(document).on('submit', '#file-storage-upload-form', function (e) {
            e.preventDefault();
            let target = document.getElementById('file-file_name');
            const file = target.files[0];
            if (!file) return;
            if (file.size > 10 * 1024 * 1024) {
                bootbox.alert('Chyba: Soubor je příliš velký. Maximální velikost je 10 MB.');
                $(this).val(''); return;
            }
            const formData = new FormData();
            formData.append('is_private', $('#file-is_private').prop('checked'));
            formData.append('is_public', $('#file-is_public').prop('checked'));
            formData.append('folder_uuid', $('#file-list-envelope').data('current_folder'));
            formData.append('file', file);
            const label = $(this).closest('.form-group').find('label');
            label.text('Nahrávám soubor...');
            $(this).prop('disabled', true);
            fetch($('#file-file_name').data('upload-url'), {
                method: 'POST', body: formData,
                headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') }
            })
                .then(response => response.json())
                .then(data => {
                    if (data.success) {
                        loadFiles($('#file-list-envelope').data('current_folder'));
                    } else {
                        bootbox.alert('Chyba při nahrávání: ' + data.error);
                    }
                })
                .catch(error => {
                    console.error('Upload error:', error);
                    bootbox.alert('Došlo k neočekávané chybě při nahrávání souboru.');
                })
                .finally(() => {
                    $('#uploadFileModal').modal('hide');
                });
        });

        $(document).on('submit', '#file-storage-create-folder-form', function (e) {
            e.preventDefault();
            const formData = new FormData();
            formData.append('is_private', $('#filefolder-is_private').prop('checked'));
            formData.append('is_public', $('#filefolder-is_public').prop('checked'));
            formData.append('name', $('#filefolder-name').val());
            formData.append('current_folder', $('#file-list-envelope').data('current_folder'));
            const label = $(this).closest('.form-group').find('label');
            label.text('vytvářím složku...');
            $(this).prop('disabled', true);
            fetch($('#file-storage-create-folder-form').attr('action'), {
                method: 'POST', body: formData,
                headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') }
            })
                .then(response => response.json())
                .then(data => {
                    if (data.success) {
                        document.location = $('#file-list-panel').data('page_refresh_url') + data.folder_uuid;
                    } else {
                        bootbox.alert('Chyba při vytváření složky: ' + data.error);
                    }
                })
                .catch(error => {
                    console.error('Upload error:', error);
                    bootbox.alert('Došlo k neočekávané chybě při vytváření složky souboru.');
                })
                .finally(() => {
                    $('#addFolderModal').modal('hide');
                });
        });

        $(document).on('submit', '#file-storage-update-folder-form', function (e) {
            e.preventDefault();
            const formData = new FormData();
            formData.append('is_private', $('#folder-update-form-is_private').prop('checked'));
            formData.append('is_public', $('#folder-update-form-is_public').prop('checked'));
            formData.append('name', $('#folder-update-form-name').val());
            formData.append('current_folder', $('#file-list-envelope').data('current_folder'));
            const label = $(this).closest('.form-group').find('label');
            label.text('upravuji složku...');
            $(this).prop('disabled', true);
            fetch($('#file-storage-update-folder-form').attr('action') + $('#file-list-envelope').data('current_folder'), {
                method: 'POST', body: formData,
                headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') }
            })
                .then(response => response.json())
                .then(data => {
                    if (data.success) {
                        document.location = $('#file-list-panel').data('page_refresh_url') + data.folder_uuid;
                    } else {
                        bootbox.alert('Chyba při vytváření složky: ' + data.error);
                    }
                })
                .catch(error => {
                    console.error('Upload error:', error);
                    bootbox.alert('Došlo k neočekávané chybě při vytváření složky souboru.');
                })
                .finally(() => {
                    $('#addFolderModal').modal('hide');
                });
        });

        $(document).on('change', '.order_select', function(e) {
            e.preventDefault();
            const order_type = $(this).val();
            const current_folder = $('#file-list-envelope').data('current_folder');
            loadFiles(current_folder, order_type);
        });

        // ---- Folder access management ----

        function loadFolderAccess(folderUuid) {
            if (!folderUuid) {
                $('#folder-access-list').html('<p class="text-muted fs-9">Přístupy lze nastavit pouze pro podsložky, ne pro kořenový adresář.</p>');
                return;
            }
            const url = $('#file-list-panel').data('get_folder_access_url') + folderUuid;
            fetch(url)
                .then(r => r.json())
                .then(data => {
                    if (data.success) {
                        $('#folder-access-list').html(data.content);
                    } else {
                        $('#folder-access-list').html('<p class="text-muted fs-9">' + data.error + '</p>');
                    }
                })
                .catch(() => {
                    $('#folder-access-list').html('<p class="text-danger fs-9">Chyba při načítání přístupů.</p>');
                });
        }

        function loadFolderOwner(folderUuid) {
            if (!folderUuid) {
                $('#folder-owner-panel').html('<p class="text-muted fs-9">Vlastníka lze změnit pouze u podsložek, ne u kořenového adresáře.</p>');
                return;
            }
            const url = $('#file-list-panel').data('get_folder_owner_url') + folderUuid;
            fetch(url)
                .then(r => r.json())
                .then(data => {
                    if (data.success) {
                        $('#folder-owner-panel').html(data.content);
                    } else {
                        $('#folder-owner-panel').html('<p class="text-muted fs-9">' + data.error + '</p>');
                    }
                })
                .catch(() => {
                    $('#folder-owner-panel').html('<p class="text-danger fs-9">Chyba při načítání vlastníka.</p>');
                });
        }

        $('#updateFolderModal').on('show.bs.modal', function () {
            const folderUuid = $('#file-list-envelope').data('current_folder');
            loadFolderAccess(folderUuid || '');
            loadFolderOwner(folderUuid || '');
        });

        // Change folder owner
        $(document).on('submit', '#folder-change-owner-form', function (e) {
            e.preventDefault();
            const folderUuid = $('#file-list-envelope').data('current_folder');
            const formData = new FormData(this);
            formData.append('folder_uuid', folderUuid);
            fetch($(this).data('url'), {
                method: 'POST',
                body: formData,
                headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') }
            })
                .then(r => r.json())
                .then(data => {
                    if (data.success) {
                        document.location = $('#file-list-panel').data('page_refresh_url') + folderUuid;
                    } else {
                        bootbox.alert('Chyba: ' + data.error);
                    }
                })
                .catch(error => {
                    console.error('Change owner error:', error);
                    bootbox.alert('Došlo k neočekávané chybě při změně vlastníka.');
                });
        });

        // Toggle user/role select in access form
        $(document).on('change', '#folder-access-type', function () {
            if ($(this).val() === 'role') {
                $('#folder-access-user-div').addClass('d-none');
                $('#folder-access-role-div').removeClass('d-none');
            } else {
                $('#folder-access-user-div').removeClass('d-none');
                $('#folder-access-role-div').addClass('d-none');
            }
        });

        // Add folder access entry
        $(document).on('submit', '#folder-add-access-form', function (e) {
            e.preventDefault();
            const folderUuid = $('#file-list-envelope').data('current_folder');
            const formData = new FormData(this);
            formData.append('folder_uuid', folderUuid);
            fetch($(this).data('url'), {
                method: 'POST',
                body: formData,
                headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') }
            })
                .then(r => r.json())
                .then(data => {
                    if (data.success) {
                        loadFolderAccess(folderUuid);
                    } else {
                        bootbox.alert('Chyba: ' + data.error);
                    }
                });
        });

        // Remove folder access entry
        $(document).on('click', '.remove-folder-access', function (e) {
            e.preventDefault();
            const id = $(this).data('id');
            const folderUuid = $('#file-list-envelope').data('current_folder');
            const baseUrl = $('#folder-add-access-form').data('remove-url');
            fetch(baseUrl + id, {
                method: 'POST',
                headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') }
            })
                .then(r => r.json())
                .then(data => {
                    if (data.success) {
                        loadFolderAccess(folderUuid);
                    } else {
                        bootbox.alert('Chyba: ' + data.error);
                    }
                });
        });

    }

    // --- Page Initializer ---
    initializeFileList(); // For view/update pages that have a slider on load

});